/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

// const { init } = require("browser-sync");


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  $(document).on('click', '.tab-link', function() {
    var tabIndex = $(this).data('tab');
    console.log('tab: ', tabIndex);
    $(".tab-collection-link").hide();
    $(".tab-collection-link-"+tabIndex).fadeIn(1000);
  });

  // Slick
  if ($('.brick__custom__collection').length) {
    $('.brick__custom__collection').slick({
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      autooplay: false,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#020202" d="M1.116 10.884a1.25 1.25 0 0 1 0-1.768l7.955-7.955A1.25 1.25 0 1 1 10.84 2.93L3.768 10l7.07 7.071a1.25 1.25 0 1 1-1.767 1.768l-7.955-7.955Zm1.765.366H2v-2.5h.881v2.5Z"/> </svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#020202" d="M10.884 10.884a1.25 1.25 0 0 0 0-1.768L2.929 1.161A1.25 1.25 0 1 0 1.16 2.93L8.232 10l-7.07 7.071a1.25 1.25 0 1 0 1.767 1.768l7.955-7.955Zm-1.765.366H10v-2.5h-.881v2.5Z"/> </svg></button>'
    });
  }
  $('.slider_status--true').slick({
    dots: true,
    variableWidth: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9587 22.12L14.8291 16L20.9587 9.88L19.0716 8L11.0415 16L19.0716 24L20.9587 22.12Z" fill="#1D4991"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.0413 22.12L17.171 16L11.0413 9.88L12.9284 8L20.9585 16L12.9284 24L11.0413 22.12Z" fill="#1D4991"/></svg></button>'
    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       arrows: false
    //     }
    //   }
    //]
  });

  // Testimonial Sliders
  if ($('.custom--section-testimonial .testimonial-slider').length) { 
    $('.custom--section-testimonial .testimonial-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true
    });
  }

  // Product Sliders
  if ($('.custom--section-featured-collection .js-grid').length) { 
    $('.custom--section-featured-collection .js-grid').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#fff" d="M1.116 10.884a1.25 1.25 0 0 1 0-1.768l7.955-7.955A1.25 1.25 0 1 1 10.84 2.93L3.768 10l7.07 7.071a1.25 1.25 0 1 1-1.767 1.768l-7.955-7.955Zm1.765.366H2v-2.5h.881v2.5Z"/> </svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#fff" d="M10.884 10.884a1.25 1.25 0 0 0 0-1.768L2.929 1.161A1.25 1.25 0 1 0 1.16 2.93L8.232 10l-7.07 7.071a1.25 1.25 0 1 0 1.767 1.768l7.955-7.955Zm-1.765.366H10v-2.5h-.881v2.5Z"/> </svg></button>',
      dots: false,
      responsive:[
        {
          breakpoint: 900,
          settings:{
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings:{
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

    // subcollections__slider
    if ($('.subcollections__slider').length) { 
      var $status = $('.pagingInfo');
      var $slickElement = $('.subcollections__slider');
  
      $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          $status.text(i + ' / ' + slick.slideCount);
      });

      $('.subcollections__slider').slick({
        infinite: false,
        slidesToShow: 4.1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $(".slick-prev"),
        nextArrow: $(".slick-next"),
        dots: false,
        responsive:[
          {
            breakpoint: 900,
            settings:{
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings:{
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }


    	// update cart number on cart page
      document.addEventListener('theme:cart:change', function(event) {
        var cart = event.detail.cart;
        var cart_price = event.detail.cart.total_price;
        if (cart) {
          let cart_count = cart.item_count;
          let formatted_price = (cart_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

      
          if (cart_count == 1) {
            $('.general-title-count span').text(cart.item_count.toString() + " item");
          } else {
            $('.general-title-count span').text(cart.item_count.toString() + " items");
          }
          // console.log(formatted_price)
      
          $('.cart-total-price').text(formatted_price);
        }
      });

	// focus on search dropdown when clicked
	$('.desktop-search').click(function (e){
		e.preventDefault();
		$('#search-popdown').addClass('is-visible');
		$('.search__predictive__main input[type="search"]').focus();
	});

	// search dropdown
	$('#searchLink').click(function (e) {
		e.preventDefault();
		setTimeout(function (){	
			$(".search__predictive__form__button").click();
		}, 100)
	});
  
  // Temp hack for custom header v2 nav. 
// $('#shopify-section-custom-header-v2 .drawer__button.drawer__close , .header__drawer .drawer__menu:not(.consolidate) .sliderule__wrapper .sliderule__wrapper .mobile__menu__dropdown>.sliderow *').click(function (){
// 	$('.drawer__inner *').removeClass('is-visible');
// });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();



'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  // Find and initialise the correct function based on the method set in the config
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};


function watchTextChange() {
  // Select the target nodes
  const targetNode = document.querySelector('.cart-total-price');
  const messageElement = document.querySelector('.cart__message');
  const defaultMessageElement = messageElement.querySelector('.cart__message-default');

  // Function to update the message and class based on the current price
  function updateMessage() {
    const price = parseFloat(targetNode.textContent.trim().replace('$', '').replace(/,/g, ''));
    const dataLimit = parseFloat(messageElement.dataset.limit);

    if (price > dataLimit) {
      // messageElement.textContent = 'Cart total exceeds the limit!';
      messageElement.classList.add('is-success');
      defaultMessageElement.textContent = ''; // Clear the default message
    } else {
      const remainingAmount = dataLimit - price;
      defaultMessageElement.textContent = 'Spend $' + remainingAmount.toFixed(2) + " more for free shipping";
      messageElement.classList.remove('is-success');
    }
  }

  // Update the message and class immediately
  updateMessage();

  // Create a new MutationObserver instance
  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        // Text content has changed, update the message and class
        updateMessage();
        break; // Exit the loop after the first mutation
      }
    }
  });

  // Start observing the target node for changes in text content and child nodes
  observer.observe(targetNode, { characterData: true, childList: true, subtree: true });
}

// Call the function to start watching for text changes and update the message
if( $("#your-shopping-cart").length ){
  watchTextChange();
}


// Close Bundle Builder "View More" on add
$("body").on("click", ".bundle-builder-app--bundle--product-add-button", function () {
  $(".bundle-builder-app--bundle-contents-modal--close").click();
});